module.exports = __webpack_public_path__ + "static/media/07.0943859c.jpg";